import { render } from "./ServiceAgreementLink.vue?vue&type=template&id=5c9aa185&scoped=true"
import script from "./ServiceAgreementLink.vue?vue&type=script&lang=js"
export * from "./ServiceAgreementLink.vue?vue&type=script&lang=js"

import "./ServiceAgreementLink.vue?vue&type=style&index=0&id=5c9aa185&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c9aa185"]])

export default __exports__